import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.documents');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

const DEFAULT_PAGE_SIZE = 21;

@Component({
    selector: 'wiz-page-documents',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.documents/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDocumentsComponent implements OnInit {
    public loading: boolean = false;
    public error: any = null;
    public source: any = {};
    public metrics: any = {};
    public items: any[] = [];
    public page: number = 1;
    public dump: number = DEFAULT_PAGE_SIZE;
    public total: number = 0;
    public hasPrevious: boolean = false;
    public hasNext: boolean = false;

    public query: string = '';
    public stageFilter: string = 'all';
    public reviewFilter: string = 'all';
    public sort: string = 'workflow';
    public detailOpen: boolean = false;
    public detailLoading: boolean = false;
    public selected: any = null;
    public detail: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        if (this.loading) return;
        this.loading = true;
        this.error = null;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('overview', {
                query: this.query,
                stage: this.stageFilter,
                review_status: this.reviewFilter,
                page: this.page,
                dump: this.dump,
                sort: this.sort,
            });
            if (code !== 200 || !data || data.source?.status === 'error') {
                throw data?.source?.error || new Error('invalid_response');
            }
            this.source = data.source || {};
            this.metrics = data.metrics || {};
            this.items = Array.isArray(data.items) ? data.items : [];
            this.page = Number(data.page) || 1;
            this.dump = Number(data.dump) || DEFAULT_PAGE_SIZE;
            this.total = Number(data.total) || 0;
            this.hasPrevious = data.has_previous === true;
            this.hasNext = data.has_next === true;
        } catch (error) {
            this.error = {
                message: error && error.message
                    ? error.message
                    : '문헌 작업 목록을 불러오지 못했습니다.',
            };
            this.items = [];
            this.total = 0;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async applyFilters() {
        this.page = 1;
        await this.load();
    }

    public async resetFilters() {
        this.query = '';
        this.stageFilter = 'all';
        this.reviewFilter = 'all';
        this.sort = 'workflow';
        this.page = 1;
        await this.load();
    }

    public async movePage(delta: number) {
        const next = this.page + delta;
        if (next < 1 || (delta < 0 && !this.hasPrevious) || (delta > 0 && !this.hasNext)) {
            return;
        }
        this.page = next;
        await this.load();
    }

    public async openSidebar() {
        await this.service.status.toggle('navbar', false);
    }

    public go(url: string) {
        if (typeof url === 'string' && url.startsWith('/')) {
            location.href = url;
        }
    }

    public async openDetail(item: any) {
        if (!item?.id || this.detailLoading) return;
        this.selected = item;
        this.detail = null;
        this.detailOpen = true;
        this.detailLoading = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('detail', {
                document_id: item.id,
            });
            if (code !== 200 || !data?.document) {
                throw data?.source?.error || new Error('invalid_response');
            }
            this.detail = data;
        } catch (error) {
            this.detail = {
                error: {
                    message: error && error.message
                        ? error.message
                        : '문헌 정보를 불러오지 못했습니다.',
                },
            };
        } finally {
            this.detailLoading = false;
            await this.service.render();
        }
    }

    public async closeDetail() {
        this.detailOpen = false;
        await this.service.render();
    }

    public formatNumber(value: any) {
        return new Intl.NumberFormat('ko-KR').format(Number(value) || 0);
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(date);
    }

    public availabilityLabel(item: any) {
        const availability = item?.availability || {};
        const labels: string[] = [];
        if (availability.xml) labels.push('XML');
        if (availability.ocr) labels.push('OCR');
        if (availability.pages) labels.push('페이지');
        if (availability.chunks) labels.push('청크');
        return labels.length ? labels.join(' · ') : '제공 없음';
    }

    public publicationLabel(status: string) {
        return ({ published: '게시', draft: '초안', archived: '보관' } as any)[status]
            || status
            || '-';
    }

    public stageLabel(stage: string) {
        return ({
            not_started: '미시작',
            source: '원문 준비',
            entity: '개체 검수',
            relation: '관계 검수',
            graph: '그래프 확정',
        } as any)[stage] || stage || '-';
    }

    public stateLabel(state: string) {
        return ({
            not_started: '미시작',
            unavailable: '없음',
            available: '이용 가능',
            partial: '일부 준비',
            ready: '산출물 준비',
            review_required: '검수 필요',
            held: '보류',
            provisional: '임시',
            completed: '완료',
            error: '확인 필요',
        } as any)[state] || state || '-';
    }

    public stateClass(state: string) {
        const styles: any = {
            completed: 'border-green-200 bg-green-50 text-green-700',
            ready: 'border-blue-200 bg-blue-50 text-blue-700',
            available: 'border-blue-200 bg-blue-50 text-blue-700',
            review_required: 'border-amber-200 bg-amber-50 text-amber-800',
            pending: 'border-amber-200 bg-amber-50 text-amber-800',
            held: 'border-violet-200 bg-violet-50 text-violet-700',
            provisional: 'border-orange-200 bg-orange-50 text-orange-700',
            error: 'border-red-200 bg-red-50 text-red-700',
            blocked: 'border-red-200 bg-red-50 text-red-700',
        };
        return styles[state] || 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.total / this.dump));
    }
}

export default PageDocumentsComponent;